import React from 'react';
import AmbassadorFeedbackBar from 'components/molecules/ambassador_feedback_bar';
import { useAmbassadorTesting } from 'hooks/useAmbassadorTesting';

interface AmbassadorToolFeedbackProps {
  toolSlug: string;
}

// Barra de feedback para as páginas da ferramenta que rolam normalmente; fica
// no fim do conteúdo e só aparece para o embaixador com o teste em andamento.
const AmbassadorToolFeedback: React.FC<AmbassadorToolFeedbackProps> = ({ toolSlug }) => {
  const testing = useAmbassadorTesting(toolSlug);
  if (!testing) return null;

  return <AmbassadorFeedbackBar toolSlug={toolSlug} reserveSpace />;
};

export default AmbassadorToolFeedback;
